import { useEffect, useMemo, useState } from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { useDebounce } from '../../shared/hooks';
import { CultivosService } from '../services/api/cadastros/CultivosService';


type TAutoCompleteOption = {
  idcultivo: string;
  label: string;
}

interface IAutoCompleteFazendaProps {
  isExternalLoading?: boolean;
  uuidCultivo?: (novoTextoselect: string | undefined) => void;
  descricao?: (novoTextoselect: string | undefined) => void;
}
export const AutoCompleteCultivo01: React.FC<IAutoCompleteFazendaProps> = ({ isExternalLoading = false, uuidCultivo, descricao }) => {
  
  const { debounce } = useDebounce();

  const [selectedId, setSelectedId] = useState<string | undefined>('');

  const [opcoes, setOpcoes] = useState<TAutoCompleteOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [busca, setBusca] = useState('');

  useEffect(() => {
    setIsLoading(true);

    debounce(() => {
      CultivosService.getAlllist(busca, selectedId)
        .then((result) => { 
          setIsLoading(false); 

          if (result instanceof Error) {
            // alert(result.message);
          } else {
            setOpcoes(result.data.map(cultivo => ({ idcultivo: cultivo.idcultivo, label: cultivo.descricao })));
          }
        });
    });
  }, [busca, selectedId]);

  const autoCompleteSelectedOption = useMemo(() => {
    if (!selectedId) return null;

    const selectedOption = opcoes.find(opcao => opcao.idcultivo === selectedId);
    if (!selectedOption) return null;
 
    return selectedOption;
  }, [selectedId, opcoes]);


  return (
    <Autocomplete
      openText='Abrir'
      closeText='Fechar'
      noOptionsText='Sem opções'
      loadingText='Carregando...'
      disablePortal
      options={opcoes}
      loading={isLoading}
      disabled={isExternalLoading}
      value={autoCompleteSelectedOption}
      onInputChange={(_, newValue) => setBusca(newValue)}
      onChange={(_, newValue) => { setSelectedId(newValue?.idcultivo); uuidCultivo?.(newValue?.idcultivo); descricao?.(newValue?.label); setBusca('');  }}
      popupIcon={(isLoading) ? <CircularProgress size={28} /> : undefined}
      renderInput={(params) => (
        <TextField
          {...params}
          size='small'
          label="Cultivo"
        />
      )}
    />
  );
};